export const educationData = [
    {
        id: 1,
        institution: 'Central University of Technology',
        course: 'Information Technology in Software Development(incomplete)',
        startYear: '2017',
        endYear: '2019'
    },
    {
        id: 2,
        institution: 'Havard CS50',
        course: 'Introductions to Computer Science',
        startYear: '2023',
        endYear: '2023'
    },
    {
        id: 3,
        institution: 'Holberton',
        course: 'Computer Science',
        startYear: '2024',
        endYear: '2024'
    },
    
]